export default __webpack_public_path__ + "static/media/anweshgangula.c19a85af.webp";